<template>
  <component :is="viewname" :cloudaccount="cloudaccount" :cloudregions="cloudregions" :loading="loading" :key="updated"  @changeView="changeView"  />
</template>

<script>
import { mapGetters } from 'vuex'
import { CLOUDACCOUNT_SETUP_STATUS } from '../../consts'
import CloudAccountSetup from '../sections/CloudAccountSetup'
import CloudAccountSetupSummary from '../sections/CloudAccountSetupSummary'
import CloudAccountSetupEmptyPage from '../sections/CloudAccountSetupEmptyPage'
import { getRequestT } from '@/utils/utils'

export default {
  name: 'CloudAccountSetupDetails',
  components: {
    CloudAccountSetup,
    CloudAccountSetupSummary,
    CloudAccountSetupEmptyPage,
  },
  props: {
    cloudaccount: {
      type: Object,
      required: true,
    },
    viewname: {
      type: String,
      deault: 'CloudAccountSetupEmptyPage',
      required: true,
    },
    filterParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      regions: this.$list.createList(this, {
        resource: 'cloudregions',
        apiVersion: 'v2',
        getParams: this.getParams,
      }),
      loading: false,
      updated: 0,
      vpcs: [],
      networks: [],
      providers: [],
      cloudproviderregions: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope']),
    cloudregions () {
      if (this.regions.data) {
        return Object.values(this.regions.data).map(item => {
          return {
            id: item.data.id,
            name: item.data.name,
            status: item.data.status,
            provider: item.data.provider,
            external_id: item.data.external_id,
            vpc_count: item.data.vpc_count,
            network_count: item.data.network_count,
            setup: { status: 'checking', ...CLOUDACCOUNT_SETUP_STATUS.checking },
            related: { vpcs: [], networks: [], providers: [], cloudproviderregions: [] },
          }
        })
      } else {
        return []
      }
    },
  },
  watch: {
    cloudaccount (val, oldval) {
      if (val.id && val.id !== oldval.id) {
        this.loading = true
        this.$nextTick(() => {
          this.fetchRegions()
        })
      }
    },
    cloudregions (items) {
      this.fullFillRegions(items).then((res) => {
        this.cloudaccount.regions = items
        this.$emit('updateCloudregions', items)
      })
    },
  },
  created () {
    this.fetchRegions()
  },
  methods: {
    async fetchResources (key, params, callback) {
      try {
        const res = await new this.$Manager(key).list({
          params: { cloudaccount_id: this.cloudaccount.id, limit: 1024, scope: this.scope, details: true, $t: getRequestT(), ...params },
        })

        if (res.data && res.data.total && res.data.total > 0) {
          callback(res.data.data)
        } else {
          const ret = []
          callback(ret)
        }
      } catch (e) {
        throw e
      }
    },
    async fetchVpcs () {
      await this.fetchResources('vpcs', { status: 'available' }, (ret) => { this.vpcs = ret })
    },
    async fetchNetworks () {
      await this.fetchResources('networks', { status: 'available' }, (ret) => { this.networks = ret })
    },
    async fetchProviders () {
      await this.fetchResources('cloudproviders', {}, (ret) => { this.providers = ret })
    },
    async fetchCloudproviderregions () {
      await this.fetchResources('cloudproviderregions', {}, (ret) => { this.cloudproviderregions = ret })
    },
    getCloudregionSetupStatus (cloudregion) {
      // cloudregion 启用禁用
      if (cloudregion.status !== 'inservice') {
        return 'disabled'
      }

      // cloudprovider region status
      const prs = this.cloudproviderregions.filter(item => { return item.cloudregion_id === cloudregion.id })
      cloudregion.related.cloudproviderregions = prs
      if (prs.length === 0) {
        return 'cloudproviderregion_not_found'
      }

      const pr = prs[0]
      // provider region 已启用
      if (!pr.enabled) {
        return 'disabled'
      } else if (['syncing', 'queued', 'queuing', 'error'].indexOf(pr.sync_status) >= 0) {
        return pr.sync_status
      }

      // cloudprovider status
      const ps = this.providers.filter(p => { return p.id === pr.cloudprovider_id })
      cloudregion.related.providers = ps
      if (ps.length === 0) {
        return 'cloudprovider_not_found'
      }

      const p = ps[0]
      if (['init', 'disconnected', 'deleting', 'deleted', 'delete_failed', 'sync_network'].indexOf(p.status) >= 0) {
        return p.status
      }

      // cloudprovider 健康状态
      if (['insufficient', 'suspended', 'arrears', 'unknown'].indexOf(p.health_status) >= 0) {
        return p.status
      }

      // 检查VPC配置
      const vs = this.vpcs.filter(v => { return v.cloudregion_id === cloudregion.id })
      cloudregion.related.vpcs = vs
      if (vs.length === 0) {
        return 'setup_vpc'
      }

      // 检查子网配置
      const ns = this.networks.filter(v => { return v.cloudregion_id === cloudregion.id })
      cloudregion.related.networks = ns
      if (ns.length === 0) {
        return 'setup_network'
      } else {
        return 'configured'
      }
    },
    async fullFillRegions (cloudregions) {
      this.loading = true
      try {
        await this.fetchVpcs()
        await this.fetchNetworks()
        await this.fetchProviders()
        await this.fetchCloudproviderregions()

        for (const item of cloudregions) {
          const status = this.getCloudregionSetupStatus(item)
          if (CLOUDACCOUNT_SETUP_STATUS.hasOwnProperty(status)) { item.setup = { status: status, ...CLOUDACCOUNT_SETUP_STATUS[status] } }
          this.$nextTick(() => {
            this.updated += 1
          })
        }
        this.loading = false
      } catch (e) {
        // todo: 加载页面异常
        this.loading = false
        throw e
      }
    },
    fetchRegions () {
      if (this.cloudaccount && this.cloudaccount.id) {
        this.regions.fetchData(0, 200)
      }
    },
    changeView (v) {
      this.$emit('changeView', v)
    },
    getParams () {
      return { account: this.cloudaccount.id }
    },
  },
}
</script>

<style scoped>

</style>
